import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminLayout.scss';

const NAV_ITEMS = [
  { path: '/admin',              label: 'Tableau de bord', icon: '📊' },
  { path: '/admin/programmes',   label: 'Programmes',      icon: '🎓' },
  { path: '/admin/utilisateurs', label: 'Utilisateurs',    icon: '👥' },
  { path: '/admin/actualites',   label: 'Actualités',      icon: '📰' },
];

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/connexion');
  };

  return (
    <div className="admin-layout">
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="admin-sidebar-header">
          <Link to="/" className="admin-brand">
            <span className="brand-icon">⚡</span>
            <span className="brand-text">BE TALENTED</span>
          </Link>
          <button className="sidebar-close" onClick={() => setSidebarOpen(false)}>✕</button>
        </div>

        <div className="admin-badge">Administration</div>

        <nav className="admin-nav">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`admin-nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-user-info">
            <div className="admin-avatar">
              {user?.prenom?.[0]}{user?.nom?.[0]}
            </div>
            <div className="admin-user-details">
              <span className="admin-user-name">{user?.prenom} {user?.nom}</span>
              <span className="admin-user-role">Administrateur</span>
            </div>
          </div>
          <button className="admin-logout-btn" onClick={handleLogout}>
            🚪 Déconnexion
          </button>
        </div>
      </aside>

      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      <main className="admin-main">
        <header className="admin-topbar">
          <button className="menu-toggle" onClick={() => setSidebarOpen(true)}>☰</button>
          <div className="topbar-right">
            <Link to="/" className="topbar-link" target="_blank" rel="noreferrer">
              Voir le site ↗
            </Link>
          </div>
        </header>

        <div className="admin-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
